import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import LoadingPage from '../ui/pages/loading/loading-page'

export class LoadingClass {
    getRoutes() {
        return (
            <Router>
                <Routes>
                    <Route path="*" element={<LoadingPage/>} />
                </Routes>
            </Router>
        )
    }
}
